import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
import { BsCheckCircleFill, BsFillCircleFill } from 'react-icons/bs';
import styled from 'styled-components';

interface IProcessedMarkProps extends React.AllHTMLAttributes<HTMLDivElement> {
	processedTs?: number;
	youtubeId: string;
}
const ProcessedMark = ({ processedTs, youtubeId }: IProcessedMarkProps) => {
	const dt = dayjs(processedTs);
	const Icon = processedTs ? BsCheckCircleFill : BsFillCircleFill;

	return (
		<MarkButton
			className={classNames(
				// 'link-button position-absolute bottom-100 start-50 translate-middle-x videos__processed-mark d-flex rounded-circle border border-2',
				'link-button position-absolute top-0 start-50 translate-middle videos__processed-mark d-flex rounded-circle border border-2',
				// processedTs ? 'border-transparent' : 'border-success'
				processedTs ? 'border-transparent' : 'border-success'
			)}
			data-youtube-id={youtubeId}
		>
			{processedTs ? (
				<Icon className="text-success" title={`Оброблено ${dt.fromNow()} (${dt.format('L LT')})`} />
			) : null}
		</MarkButton>
	);
};

export default ProcessedMark;

const MarkButton = styled.button`
	background-color: var(--bs-body-bg);
	width: 1.5rem;
	height: 1.5rem;
	font-size: 1.5rem;
	box-sizing: content-box;
	/* margin-bottom: 0.33rem; */
`;
